import { GatsbyBrowser } from "gatsby"
import * as React from "react"

import { CookiesProvider } from "react-cookie"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import "./src/styles/global.css"

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
}) => (
  <GoogleReCaptchaProvider reCaptchaKey="6LemLlsfAAAAAOZaLTN_9LJJjoubJ05-z4JYTzcp">
    <CookiesProvider>{element}</CookiesProvider>
  </GoogleReCaptchaProvider>
)

// gatsby-plugin-offline's service worker now skips waiting/claims clients
// (see gatsby-config.ts), so as soon as a new SW has installed we reload
// once to pick up the fresh precache instead of leaving visitors on stale
// content until they manually clear it.
export const onServiceWorkerUpdateReady: GatsbyBrowser["onServiceWorkerUpdateReady"] =
  () => {
    window.location.reload()
  }
